import styled from "styled-components";
import {useClientContext} from "../hooks/useContext";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {getTheme} from "../shared/themeUtils";

const Contain = styled.div`
    position: fixed;
    width: 50px;
    right: 100px;
    bottom: ${getTheme("space.3")};
    border: 1px solid ${getTheme("colors.primary")};
    background: #fff;
    padding: 10px;
    border-radius: 30px;
    img {
        width: 100%;
    }
    @media (max-width: ${getTheme("breakpoints.0")}) {
        bottom: ${getTheme("space.2")};
        right: 80px;
    }
`
const InvocaLinked = () => {
  const contextQuery = useClientContext()

  const tooltip = (
    <Tooltip id={"tooltip"}>
      Your session is linked to invoca
    </Tooltip>
  )

  if (contextQuery.data && contextQuery.data.isInvocaLinked) {
    return (
      <Contain>
        <OverlayTrigger placement="top" overlay={tooltip}>
        <img src='/icons/invocaicon.png' alt="invoca"/>
        </OverlayTrigger>
      </Contain>
    )
  }

  return (
    <></>
  )
}

export default InvocaLinked